import React from 'react';
import useGradesTableStore from '../store/useGradesTableStore';
import AssignmentsRow from './Rows/AssignmentsRow';
import StudentRow from './Rows/StudentsRow';
import Legend from './Legend';
import styles from './styles.module.scss';

const Table = () => {
  const students = useGradesTableStore(state => state.students);

  return (
    <figure>
      <div className={styles.assignmentsGradesTableWrapper}>
        <table className={styles.assignmentsGradesTable}>
          <thead>
            <AssignmentsRow />
          </thead>
          <tbody>
            {students.map(student => (
              <StudentRow student={student} />
            ))}
          </tbody>
        </table>
      </div>
      <figcaption>
        {students.length > 0 && <Legend />}
      </figcaption>
    </figure>
  );
};

export default Table;
